export const ACCEPT_REFUSE_WITHDRAWS_SUCCESS = 'ACCEPT_REFUSE_WITHDRAWS_SUCCESS';
export const ACCEPT_REFUSE_WITHDRAWS_LOADING = 'ACCEPT_REFUSE_WITHDRAWS_LOADING';
export const ACCEPT_REFUSE_WITHDRAWS_ERROR = 'ACCEPT_REFUSE_WITHDRAWS_ERROR';